export default {
  VEHICLE_WIDGET_COLLAPSIBLE_CLASS: `{this.collapsed ? 'cm_collapsed' : ''}`,
};
